import { createFileRoute } from '@tanstack/react-router'
import { PreCheckoutPage } from './-components/pre-checkout-page'

export const Route = createFileRoute('/mrgolisoda/pre-checkout/')({
  validateSearch: (search: Record<string, unknown>) => ({
    session_id: search.session_id != null ? Number(search.session_id) : undefined,
  }),
  component: PreCheckoutPage,
})
